module.exports = __webpack_public_path__ + "img/Microsoft_logo.363fdd53.svg";